import { Avatar as MuiAvatar } from "@material-ui/core";
import styled from "styled-components";

export const Avatar = styled(MuiAvatar)`
	text-decoration: none;
	color: ${({ theme }) => theme.palette.Avatar.textColor};
	background-color: ${({ theme, src }) => (!!src ? "transparent" : theme.palette.Avatar.bgColor)};
`;
